module.exports = __webpack_public_path__ + "static/img/bg2.cefe5e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/bg2.png
// module id = TSNd
// module chunks = 70